import { useQueryClient } from "@tanstack/react-query";
import { useMapUnknownRight } from "src/services/admin/commands/unknownRights";
import SnackbarUtils from "src/utils/SnackbarUtils";

import { UnknownRights } from "../../Type";

export const useSaveRight = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		SnackbarUtils.success("Se ha guardado el derecho.");
		queryClient.setQueryData(["adminUnknownRights"], []);
		queryClient.refetchQueries({
			queryKey: ["adminUnknownRights"]
		});
	};

	const onError = () => {
		SnackbarUtils.error("Se ha producido un error al intentar guardar el derecho.");
	};

	const { mutate, isPending } = useMapUnknownRight();

	const onSave = (right: UnknownRights) => {
		mutate(right, { onSuccess, onError });
	};

	return { onSave, isLoading: isPending };
};
